import React from 'react';
import styled from 'styled-components';
import {motion} from 'framer-motion';
import {Link} from 'react-router-dom';

const PageWrapper = styled.div`
  width: 100%;
  height: 100vh;
  overflowX: hidden;
  overflowY: hidden;
  z-index: -1;
`
const HomePageWrapper = styled(PageWrapper)`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`

const HomeHead = styled.div`
  max-width: 520px;
  font-size: 68px;
  font-weight: 900;
  color: #242424;
  letter-spacing: 0.35rem;
  text-align: center;
  @media (max-width: 620px){
   font-size: 54px;
   letter-spacing: 0.2rem
  }
`
const CustButton = styled.button`
  outline: none;
  background: #1E73F8;
  color: white;
  text-decoration: none;
  padding: 12px 24px;
  border: none;
  border-radius: 10px;
  font-weight: 700;
  display: flex;
  font-size: 16px;
  font-family: 'Red Hat Display', 'Roboto', Arial, sans-serif;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: 35px 0 0;
  transition: 0.2s ease-in-out;
  &:hover {
    background: #1C62D1; 
  }
  &:active {
    background: #2E7FFF;
  }
`

const buttonVariant = {
  hover: {
    scale: 1.1,
    y: -10, 
    boxShadow: "0 4px 20px #00000077"
  }
} 

export default function Home() {
  return (
    <HomePageWrapper>
      
      <motion.div
        initial={{ opacity: 0, y: -50}}
        animate={{ opacity: 1, y: 0 }}
        transition={{duration: 0.6}}
      >
        <HomeHead>I am Student at UoH, India</HomeHead>
      </motion.div>
      <motion.div
        whileHover="hover"
        variants={buttonVariant}
      >
        <Link to="/about" style={{textDecoration: 'none'}}>
          <CustButton>Contact</CustButton>
        </Link>
      </motion.div>
    </HomePageWrapper>
  );
}
